import * as React from "react";
import { Authorize } from "reauthorize";

import { MessagingReplyModalButton } from "@teamprevent/common/messaging/components/MessagingReplyModalButton";
import { getAllCaseMessages } from "@teamprevent/common/messaging/actions";

import { ActionableTasksListModel } from "..";
import { CUSTOMER_ROLES } from "../../auth/model";
import { loadActionableTasks } from "../actions";

import { InsufficientInformationButton } from "./InsufficientInformationButton";
import { ManagerViewPpqReportButton } from "./ManagerViewPpqReportButton";
import { ManagerViewReferralReportButton } from "./ManagerViewReferralReportButton";
import { ManagerViewHealthSurveillanceCertificateButton } from "./ManagerViewHealthSurveillanceCertificateButton";
import { ViewImmsClearanceButton } from "./ViewImmsClearanceButton";
import { ManagerViewPhysiotherapyReferralReportButton } from "./ManagerViewPhysiotherapyReferralReportButton";
import { CompleteInitialWorkAdjustmentDetailsButton } from "./CompleteInitialWorkAdjustmentDetailsButton";
import { ManagerToProcessUpdateWorkAdjustmentQuestionnaireTaskButton } from "./ManagerToProcessUpdateWorkAdjustmentQuestionnaireTaskButton";
import { ManagerFeedbackOnReportButton } from "./ManagerFeedbackOnReportButton";
import { AssociateSentMessageAndDocumentsTaskButton } from "./AssociateSentMessageAndDocumentsTaskButton";
import { ManagerSatisfactionFollowUpQuestionnaireButton } from "./ManagerSatisfactionFollowUpQuestionnaireButton";
import { ManagerViewMHPTreatmentReportButton } from "./ManagerViewMHPTreatmentReportButton";
import {
    ManagerViewAllImmsCompletedForRoleCertificateButton
} from "./ManagerViewAllImmsCompletedForRoleCertificateButton";

export interface ActionableTaskButtonProps {
    task: ActionableTasksListModel;
}

const CreateInsufficientInformationButton = (task: ActionableTasksListModel) => (
    <InsufficientInformationButton task={task} />
);

const CreateManagerViewReferralReportButton = (task: ActionableTasksListModel) => (
    <ManagerViewReferralReportButton task={task} />
);

const CreateManagerViewPpqReportButton = (task: ActionableTasksListModel) => (
    <ManagerViewPpqReportButton task={task} />
);

const CreateManagerViewAllImmsCompletedForRoleCertificateButton = (task: ActionableTasksListModel) => (
    <ManagerViewAllImmsCompletedForRoleCertificateButton task={task} />
);

const CreateManagerViewHealthSurveillanceCertificateButton = (task: ActionableTasksListModel) => (
    <ManagerViewHealthSurveillanceCertificateButton task={task} />
);

const ViewImmsClearButton = (task: ActionableTasksListModel) => (
    <ViewImmsClearanceButton task={task} />
);

const CreateManagerViewPhysiotherapyReferralReportButton = (task: ActionableTasksListModel) => (
    <ManagerViewPhysiotherapyReferralReportButton task={task} />
);

const CreateCompleteInitialWorkAdjustmentDetailsButton = (task: ActionableTasksListModel) => (
    <CompleteInitialWorkAdjustmentDetailsButton task={task} />
);

const CreateManagerToProcessUpdateWorkAdjustmentQuestionnaireTaskButton = (task: ActionableTasksListModel) => (
    <ManagerToProcessUpdateWorkAdjustmentQuestionnaireTaskButton task={task} />
);

const ManagerFeedbackOnReportTaskButton = (task: ActionableTasksListModel) => <ManagerFeedbackOnReportButton task={task} />;

const ManagerOpenMessageTaskButton = (task: ActionableTasksListModel) => {

    const dispatchAction = () => getAllCaseMessages(task.caseId);

    return (<Authorize
        authorize={[
            CUSTOMER_ROLES.manager.name,
            CUSTOMER_ROLES.hr.name,
            CUSTOMER_ROLES.recruitmentManager.name,
            CUSTOMER_ROLES.caseManager.name,
            CUSTOMER_ROLES.customerAdministrator.name
        ]}>
        <MessagingReplyModalButton
            caseId={task.caseId}
            subject={task.caseSubject}
            buttonText={"View"}
            showReply={false}
            customerId={task.customerId}
            action={loadActionableTasks}
            employeeName={task.employeeName}
            // eslint-disable-next-line react/jsx-no-bind
            onModalOpenDispatchAction={dispatchAction}
        />
    </Authorize>);
};

const AssociateSentMessageAndDocumentsButton = (task: ActionableTasksListModel) => (
    <AssociateSentMessageAndDocumentsTaskButton task={task} />
);

const ManagerSatisfactionFollowUpQuestionnaireTaskButton = (task: ActionableTasksListModel) => (
    <ManagerSatisfactionFollowUpQuestionnaireButton task={task} />
);

const ManagerViewMHPTreatmentReportTaskButton = (task: ActionableTasksListModel) => (
    <ManagerViewMHPTreatmentReportButton task={task} />
);

export const actionableTaskButtons: { [key: string]: (task: ActionableTasksListModel) => React.JSX.Element } = {
    InsufficientInformationTask: CreateInsufficientInformationButton,
    InsufficientInformationForGenericCaseTask: CreateInsufficientInformationButton,
    ManagerViewReferralReportTask: CreateManagerViewReferralReportButton,
    ManagerViewPpqReportTask: CreateManagerViewPpqReportButton,
    ManagerViewHealthSurveillanceCertificateTask: CreateManagerViewHealthSurveillanceCertificateButton,
    HealthSurveillanceCertificateCreatedTask: CreateManagerViewHealthSurveillanceCertificateButton,
    AllImmunisationsCompletedForRoleTask: CreateManagerViewAllImmsCompletedForRoleCertificateButton,
    ManagerViewImmsClearTask: ViewImmsClearButton,
    ManagerViewPhysiotherapyReferralReportTask: CreateManagerViewPhysiotherapyReferralReportButton,
    InitialWorkAdjustmentDetailsTask: CreateCompleteInitialWorkAdjustmentDetailsButton,
    ManagerToProcessUpdateWorkAdjustmentQuestionnaireTask: CreateManagerToProcessUpdateWorkAdjustmentQuestionnaireTaskButton,
    ManagerFeedbackOnReportTask: ManagerFeedbackOnReportTaskButton,
    ManagerOpenMessageTask: ManagerOpenMessageTaskButton,
    AssociateSentMessageAndDocumentsTask: AssociateSentMessageAndDocumentsButton,
    ManagerSatisfactionFollowUpQuestionnaireTask: ManagerSatisfactionFollowUpQuestionnaireTaskButton,
    ManagerViewMHPTreatmentReportTask: ManagerViewMHPTreatmentReportTaskButton
};
